<template>
  <el-table :data="tableSafetyData" stripe style="width: 100%" ref="stationTable" border v-loading="stationsLoading">

    <af-table-column prop="operatorName" :label="$t('deviceControl.operatorId')"></af-table-column>
    <af-table-column prop="matter" :label="$t('an-quan-jian-cha-shi-xiang-0')"></af-table-column>
    <af-table-column prop="stationName" :label="$t('siteManager.stationName')"></af-table-column>
    <af-table-column prop="dutyPerson" :label="$t('ke-hu-lian-xi-ren-0')"></af-table-column>
    <af-table-column prop="salesman" :label="$t('xiao-shou-ren-0')"></af-table-column>
    <af-table-column prop="warrantyPeriod" :label="$t('bao-xiu-shi-jian-1')"></af-table-column>
    <af-table-column prop="auditStatus.message" :label="$t('chargingMonitor.state')"></af-table-column>
    <af-table-column :label="$t('deviceControl.operation')" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="safetyEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:station:updateStation'])">{{ $t('alaramMonitor.edit') }}
        </el-button>
        <el-button size="mini" plain type="danger" @click="stationDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:station:deleteStation'])">{{ $t('deviceControl.delete') }}
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  import safetyApi from "../../api/safetyApi";

  export default {
    name: "list",
    data(){
      return{
      }
    },
    props:{
      tableSafetyData: {},
      stationsLoading: false,
    },
    methods:{
      safetyEdit(index,row){
        this.$emit('safetyEdit',index,row)
      },

      // 删除管理信息
      stationDelete(index, row) {
        this.$confirm(this.$t('que-ding-yao-shan-chu') + row.matter + this.$t('ma-0'), this.$t('alaramMonitor.message5'), {
          confirmButtonText: this.$t('deviceControl.confirm'),
          cancelButtonText: this.$t('alaramMonitor.cancel'),
          type: 'warning'
        })
          .then(() => {
            safetyApi.deleteSafety(row.id).then((res) => {
              console.log("删除结果：" + JSON.stringify(res))
              if (res.code === 0) {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
                this.$emit("submitSafetySearchForm")
              } else {
                this.$message.error(res.message)
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('alaramMonitor.message8')
            })
          })
      },
    },
    filters: {
      statusFilter(stationStatus) {
        const statusMap = {
          0: 'warning',
          1: 'primary',
          5: 'info',
          6: 'danger',
          50: 'success'
        }
        return statusMap[stationStatus]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/safetyManager/list.vue